export default {
	// SOLUTIONS
  'ergonomic_positiong': {
    heading: 'Ergonomic positiong',
    description: 'The design of AVE 2 with emphasis on upright birthing makes positioning ergonomic and simple. The focus on upright birth can lead to shorter and less risky birth.',
    images: [
			'ave2/01_2_Linet_Ave_2_Retractable_Foot_Section.jpg'
		]
  },
  'safety_comfort': {
    heading: 'Safety & comfort',
    description: "Mom feels supported in every stage of birth. She can adjust her position as she wishes.",
    images: [
			'ave2/Safety_Comfort.jpg'
		]
  },

	// KEY FEATURES
  'safety': {
    heading: 'Safety',
    subExplanations: [
      'cpr',
      'brakes',
      'nurse_call',
      'battery_backup',
			'trendelenburg',
			'under_carriage_light'
    ]
  },
  'cpr': {
    heading: 'CPR',
    description: 'CPR position can be accessed through a manual lever that is marked on both sides of the bed.',
    images: [
      'ave2/1.1.CPR.jpg'
    ],
		camera: {
      orbit: '-7.835rad 1.436rad 40%',
      target: '0 0 0'
    }
  },
	'brakes': {
    heading: 'Brakes',
    description: 'Double-way pedal brakes are ergonomic and color coded. The central brake system controls all four castors.',
    images: [
      'ave2/1.2.BRAKES.jpg'
    ],
		camera: {
      orbit: '-7.844rad 0.922rad 40%',
      target: '0 0m 50m'
    }
  },
	'nurse_call': {
    heading: 'Nurse Call',
    description: 'The bed is equipped with nurse call button in case of need. Once pressed, the nurse is called and mother can speak to the microphone located on the siderail.',
    images: [
      'ave2/1.3.NURSECALL.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
	'battery_backup': {
    heading: 'Battery Back-Up',
    description: 'The bed is equipped with a battery so it can be operated even without being plugged into the electricity.',
    images: [
      'ave2/1.4.BATTERYBACK-UP.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
	'trendelenburg': {
    heading: 'Trendelenburg',
    description: 'AVE 2 can be positionied into Trendelenburg with a single button.',
    images: [
      'ave2/1.5.TRENDELENBURG.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
	'under_carriage_light': {
    heading: 'Under Carriage Light',
    description: 'The light provides safety during the night when the mother wants to exit the bed. The personnel can switch it on and off.',
    images: [
      'ave2/16.UNDERCARRIAGELIGHT.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
  'positioning': {
    heading: 'Positioning',
    subExplanations: [
      'foot_section',
      'leg_rests',
      'siderails'
    ]
  },
  'foot_section': {
    heading: 'Foot section',
    description: 'The foot section can be easily moved under the bed to allow for better access to the mother and more birthing positions. This also eliminates a need to lift and remove the heavy foot section by the nurse.',
    images: [
      'ave2/2.1.FOOTSECTION.jpg'
    ],
		camera: {
      orbit: '-10.077rad 0.796rad 40%',
      target: '-20m 0 -50m'
    }
  },
  'leg_rests': {
    heading: 'Leg Rests',
    description: 'Leg rests can be positioned to facilitate the labor. They can be adjusted vertically and horizontally including the trays.',
    images: [
      'ave2/2.2.LEGRESTS_1.jpg',
      'ave2/2.2.LEGRESTS_2.jpg'
    ],
		camera: {
      orbit: '-10.077rad 0.796rad 40%',
      target: '-75m 50m -50m'
    }
  },
  'siderails': {
    heading: 'Siderails',
    description: 'The siderails can be lowered mechanically using one button. They also contain simplified control panel that can be used by the mother to increase her comfort.',
    images: [
      'ave2/23.SIDERAILS_1.jpg',
      'ave2/2.3.SIDERAILS_2.jpg'
    ],
		camera: {
      orbit: '-11.012rad 1.106rad 40%',
      target: '20m 75m 30m'
    }
  },
  'accesories': {
    heading: 'Accesories',
    subExplanations: [
      'headboard',
      'remote_controller',
      'squat_bar',
      'leg_straps',
      'iv_pole',
      'stainless_steel_tray'
    ]
  },
  'headboard': {
    heading: 'Removable Headboard',
    description: 'The Headboard can be easily removed. Once removed, the bed offers unobstructed access to the head of the mother.',
    images: [
      'ave2/3.1.HEADBOARD.jpg'
    ],
		camera: {
      orbit: '3.637rad 0.857rad 80%',
      target: '0 0 130m'
    }
  },
  'remote_controller': {
    heading: 'Remote Controller',
    description: 'AVE 2 can be equipped with remote controler that operates the backrest, seat rest and bed height. It offers easier way to adjust bed both for the nurse and the mother.',
    images: [
      'ave2/3.2.REMOTECONTROLLER.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
  'squat_bar': {
    heading: 'Squat Bar',
    description: 'Squat bar can help during the labor as a support for certain birthing positions. It is placed directly on the bed using mechanical locks.',
    images: [
      'ave2/3.3.SQUATBAR.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
  'leg_straps': {
    heading: 'Leg Straps',
    description: 'The straps provide better support during various stages of labor.',
    images: [
      'ave2/3.4.LEGSTRAPS.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  },
  'iv_pole': {
    heading: 'IV Pole',
    description: 'The bed is equipped with two slots for IV poles',
    images: [
      'ave2/3.5.IVPOLE.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 40%',
      target: '50m 0 70m'
    }
  },
  'stainless_steel_tray': {
    heading: 'Stainless Steel Tray',
    description: 'The tray is foldable and can be easily stored under the bed.',
    images: [
      'ave2/3.6.STAINLESSSTEELTRAY.jpg'
    ],
		camera: {
      orbit: '-1.638rad 1.658rad 40%',
      target: '0 0 0'
    }
  },
  'comfort': {
    heading: 'Comfort',
    subExplanations: [
      'duocoat_matress'
    ]
  },
  'duocoat_matress': {
    heading: 'DuoCoat Matress',
    description: ' Increased comfort for mom with DuoCoat mattress.',
    images: [
      'ave2/_R6A5086.jpg'
    ],
		camera: {
      orbit: '2.295rad 1.1479rad 80%',
      target: '0 0 0'
    }
  }
}
